export default __webpack_public_path__ + "static/media/logo-yellow-1.8f45c999.png";